<script setup lang="ts">
import { ref, computed } from "vue";
import InfoBanner from "@comp-lib/components/InfoBanner.vue";
import CustomButton from "@comp-lib/components/CustomButton.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { useRouter } from "vue-router";
import { currentDefaultVersion, currentVersionReleaseDate } from "@/assets/mobiusVersioningData";

const DISMISSED_BANNER_KEY = "mobius_dismissed_release_note_version";

const router = useRouter();
const isDismissed = ref(localStorage.getItem(DISMISSED_BANNER_KEY) === currentDefaultVersion);

const isReleaseDateReached = computed(() => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const releaseDate = new Date(currentVersionReleaseDate + "T00:00:00");
  return today >= releaseDate;
});

const isVisible = computed(() => isReleaseDateReached.value && !isDismissed.value);

function dismissBanner() {
  localStorage.setItem(DISMISSED_BANNER_KEY, currentDefaultVersion);
  isDismissed.value = true;
}

function handleSeeWhatsNew() {
  dismissBanner();
  router.push({ name: "ReleaseNotes", params: { version: currentDefaultVersion } });
}
</script>

<template>
  <InfoBanner v-if="isVisible" bannerType="success">
    <template #text>
      <div class="banner-content-inline">
        <p>Mobius {{ currentDefaultVersion }} is here! And it's packed with new features for you to discover.</p>
        <div class="actions">
          <CustomButton
            label="See what's new"
            green
            size="sm"
            @click="handleSeeWhatsNew"
          />
          <span v-tooltip="{ text: 'Dismiss' }" class="dismiss" @click="dismissBanner"><FontAwesomeIcon :icon="faXmark" /></span>
        </div>
      </div>
    </template>
  </InfoBanner>
</template>

<style scoped lang="scss">
.banner-content-inline {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  .actions {
    display: flex;
    gap: 20px;
    .dismiss {
      display: flex;
      align-self: flex-start;
      cursor: pointer;
      color: map.get(v.$secondary, "800");
      transition: color .2s;
      &:hover {
        color: map.get(v.$secondary, "600");
      }
    }
  }
}
</style>
